import React, { FC, useContext, useState, useEffect } from 'react';

import { navigate } from '@reach/router';

import { GlobalContext } from '../../../../store';

import Button from '../../../../components/Button';
import Input from '../../../../components/Input';
import { redWaglLogo } from '../../../../assets/images/';
import useLocation from '../../../../contrib/Hooks/useLocation.hook';
import { queryStringToObject } from '../../../../contrib/Utils/queryStringToObject';

const SetCode: FC = () => {
  const {
    actions,
    actions: {
      notifications: { pushError }
    }
  } = useContext(GlobalContext);

  const { location } = useLocation();

  const [code, setCode] = useState('');
  const [invalidCode, setInvalidCode] = useState(false);

  useEffect(() => {
    const queryStringObject = queryStringToObject(location.search);

    if (queryStringObject.invitationCode) {
      setCode(queryStringObject.invitationCode);
    }
  }, [location]);

  const next = async (): Promise<void> => {
    const response = await actions.invitation.get(code);

    if (response.errors) {
      await pushError(
        response.errors.invitation.msg || 'There was an error getting the invitations'
      );

      setInvalidCode(true);
    } else {
      if (response.invitation && response.invitation.id) {
        if (response.invitation.match) {
          navigate(`/login/${code}/`);
        } else {
          navigate(`/register/account/${code}/`);
        }
      } else {
        setInvalidCode(true);
      }
    }
  };

  const onSetCode = (event: any): void => {
    setCode(event.target.value);
  };

  return (
    <div className="set-code form">
      <div className="logo-wrapper">
        <img src={redWaglLogo} className="logo" alt="logo" />
      </div>

      <h1>INPUT YOUR INVITATION CODE</h1>

      <div className="help-text set-code__text">
        What is the 6-digit invitation code sent to you in your email?
      </div>

      <Input
        className="set-code__input"
        label="INVITATION CODE"
        fullWidth={true}
        id="invitation-code"
        type="text"
        value={code}
        onChange={onSetCode}
        hasError={code.length > 6 || (!!code && code.length < 6) || invalidCode}
        errorMessage={'The code you entered is incorrect'}
        inputProps={{ maxLength: 6 }}
      />

      <Button
        variant="contained"
        color="primary"
        disabled={code.length !== 6 || !Boolean(Number(code))}
        onClick={next}
        className="register-next-button button--shadow"
      >
        GO TO ACCOUNT SETUP
      </Button>
    </div>
  );
};

export default SetCode;
